import PlaceholderImage from '@assets/images/ImgFinal_Suitability02.png';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  ImageBox,
  SectionContainer,
} from './BrandSuitabilityThree.style';
import { useTranslation } from 'react-i18next';

const BrandSuitabilityThree = () => {
  const { t } = useTranslation('brandSuitability');

  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>
          {t('brandSuitabilityThree.title.spanBefore')}
          <span>2</span> {t('brandSuitabilityThree.title.spanAfter')}
        </h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox1>
          <div className="text-content">
            <p>{t('brandSuitabilityThree.subtitle')}</p>
          </div>
        </TextBox1>

        <TextBox2>
          <p>
            {t('brandSuitabilityThree.paragraph.spanBefore')}
            <span>2</span> {t('brandSuitabilityThree.paragraph.spanAfter')}
          </p>
        </TextBox2>
        <ImageBox>
          <img src={PlaceholderImage} alt="Imagem" />
        </ImageBox>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default BrandSuitabilityThree;
